export default {
  emailOrPhone: 'Email o teléfono',
  password: 'Contraseña',
  rememberMe: 'Recuérdame',
  forgotYourPassword: '¿Olvidaste tu clave?',
  signIn: 'Accede',
  newHere: '¿Nuevo aquí?',
  openAccount: 'Abre una cuenta',
  haveAccount: '¿Ya tienes una cuenta?',
  fullName: 'Nombre Completo',
  country: 'País', // Possible general translation
  phone: 'Teléfono',
  email: 'Email',
  iAgree: 'Estoy de acuerdo con el',
  termsAndConditions: 'Acuerdo de privacidad',
  signUp: 'Registrarme',
  recoverPassword: 'Recupera la contraseña de tu cuenta',
  recover: 'Recuperar',
  goBack: 'Volver',
  weHaveSentYouACode: 'Te hemos enviado un código a tu',
  receivedCode: 'Código recibido',
  newPassword: 'Nueva contraseña',
  confirmNewPassword: 'Confirma tu nueva clave',
  passwordSuccessfullyChanged: 'Contraseña cambiada correctamente'
}
